import BaseButton from '@/Components/atoms/BaseComponents/BaseButton';
import CommonSvg, { svgNames } from '@/Components/atoms/CommonSvg';
import Container from '@/Components/atoms/Container';
import PublicLayout from '@/Components/layouts/ResponsivePublicLayout';
import React from 'react';
import StyledNotFound from './style';
import AngleRight from '@/Components/atoms/CommonSvg/angleRight';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

type Props = {};

const NotFound = (props: Props) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  return (
    <PublicLayout>
      <StyledNotFound>
        <Container className='create-page-container' maxWidth={'900px'}>
          <div className='content'>
              <h3 className='content__title'>{t('not-found-title')}</h3>
              <div className='imgs'>
                <img src='/static/images/not-found.png' alt='' />
              </div>
              <div className='btns'>
                <BaseButton className='homepage-button' onClick={() => router.push('/')}>
                  {t('go_home')} <AngleRight />
                </BaseButton>
              </div>
            <BaseButton className='back-stage-btn' onClick={router.back}>
              <CommonSvg name={svgNames.ArrowLeft} />
            </BaseButton>
          </div>
        </Container>
      </StyledNotFound>
    </PublicLayout>
  );
};

export default NotFound;
